import { Component } from '@angular/core';

import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-full-screen-loader',
  imports: [ProgressSpinnerModule],
  templateUrl: './full-screen-loader.component.html',
  styleUrl: './full-screen-loader.component.scss',
})
export class FullScreenLoaderComponent {}
